export default {
    heading4xl: {
        fontSize: 40,
        lineHeight: '48px',
        fontWeight: 700,
        fontFamily: 'Inter'
    },
    heading3xl: {
        fontSize: 32,
        lineHeight: '40px',
        fontWeight: 700,
        fontFamily: 'Inter'
    },
    heading2xl: {
        fontSize: 28,
        lineHeight: '32px',
        fontWeight: 600,
        fontFamily: 'Inter'
    },
    headingXl: {
        fontSize: 24,
        lineHeight: '28px',
        fontWeight: 600,
        fontFamily: 'Inter'
    },
    headingLg: {
        fontSize: 20,
        lineHeight: '24px',
        fontWeight: 600,
        fontFamily: 'Inter'
    },
    headingMd: {
        fontSize: 16,
        lineHeight: '24px',
        fontWeight: 600,
        fontFamily: 'Inter'
    },
    headingSm: {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
        fontFamily: 'Inter'
    },
    headingXs: {
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 600,
        fontFamily: 'Inter'
    },
    bodyXl: {
        fontSize: 20,
        lineHeight: '20px',
        fontFamily: 'Inter'
    },
    bodyLg: {
        fontSize: 16,
        lineHeight: '20px',
        fontFamily: 'Inter'
    },
    bodyMd: {
        fontSize: 14,
        lineHeight: '20px',
        fontFamily: 'Inter'
    },
    bodySm: {
        fontSize: 12,
        lineHeight: '16px',
        fontFamily: 'Inter'
    }
};
//# sourceMappingURL=typography.js.map